<ng-container *ngIf="!hideField; else hiddenPicker">
  <mat-form-field appearance="fill" class="w-100">
    <mat-label>
      <ng-content></ng-content>
    </mat-label>
    <input
      matInput
      [formControl]="control!"
      [placeholder]="placeHolder"
      [matDatepicker]="picker"
      [min]="minDate"
      (dateChange)="confirmSelection()"
    />
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</ng-container>

<ng-template #hiddenPicker>
  <input
    class="hidden-date-input"
    [formControl]="control!"
    [matDatepicker]="picker"
    [min]="minDate"
    (dateChange)="confirmSelection()"
  />
  <mat-datepicker #picker></mat-datepicker>
</ng-template>
